var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTimesheet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "-4 0 34 34",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1 1.993c0-.55.45-.993.995-.993h17.01c.55 0 1.34.275 1.776.625l3.44 2.75c.43.345.78 1.065.78 1.622v26.006c0 .55-.447.997-1 .997H2c-.552 0-1-.452-1-.993V1.993z",
    stroke: "#474747",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#474747",
    d: "M18 2h1v6h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#474747",
    d: "M18 7h6v1h-6z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#575757"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 12h1v10H9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 18h1v4H7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 17h1v5h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 20h1v2h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 14h1v8h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 15h1v7h-1z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimesheet);
export default __webpack_public_path__ + "static/media/Timesheet.6a2bde58de024edcb6c9cdcd38d33f3c.svg";
export { ForwardRef as ReactComponent };